var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVolumeGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1340_421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1340_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.98325C12.6667 7.06103 12.4222 6.21936 11.9333 5.45825C11.4444 4.69714 10.7889 4.1277 9.96667 3.74992C9.8 3.67214 9.67778 3.5527 9.6 3.39159C9.52222 3.23047 9.51111 3.06659 9.56667 2.89992C9.63333 2.72214 9.75278 2.59436 9.925 2.51659C10.0972 2.43881 10.2722 2.43881 10.45 2.51659C11.5278 2.99436 12.3889 3.72492 13.0333 4.70825C13.6778 5.69159 14 6.78325 14 7.98325C14 9.18325 13.6778 10.2749 13.0333 11.2583C12.3889 12.2416 11.5278 12.9721 10.45 13.4499C10.2722 13.5277 10.0972 13.5277 9.925 13.4499C9.75278 13.3721 9.63333 13.2444 9.56667 13.0666C9.51111 12.8999 9.52222 12.736 9.6 12.5749C9.67778 12.4138 9.8 12.2944 9.96667 12.2166C10.7889 11.8388 11.4444 11.2694 11.9333 10.5083C12.4222 9.74714 12.6667 8.90547 12.6667 7.98325ZM4.66667 9.99992H2.66667C2.47778 9.99992 2.31944 9.93603 2.19167 9.80825C2.06389 9.68047 2 9.52214 2 9.33325V6.66658C2 6.4777 2.06389 6.31936 2.19167 6.19159C2.31944 6.06381 2.47778 5.99992 2.66667 5.99992H4.66667L6.86667 3.79992C7.07778 3.58881 7.31944 3.54159 7.59167 3.65825C7.86389 3.77492 8 3.98325 8 4.28325V11.7166C8 12.0166 7.86389 12.2249 7.59167 12.3416C7.31944 12.4583 7.07778 12.411 6.86667 12.1999L4.66667 9.99992ZM11 7.99992C11 8.46658 10.8944 8.90825 10.6833 9.32492C10.4722 9.74158 10.1944 10.0833 9.85 10.3499C9.73889 10.4166 9.625 10.4194 9.50833 10.3583C9.39167 10.2971 9.33333 10.1999 9.33333 10.0666V5.89992C9.33333 5.76659 9.39167 5.66936 9.50833 5.60825C9.625 5.54714 9.73889 5.54992 9.85 5.61659C10.1944 5.89436 10.4722 6.24436 10.6833 6.66658C10.8944 7.08881 11 7.53325 11 7.99992Z",
    fill: "#18A84D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVolumeGreen);
export default __webpack_public_path__ + "static/media/ic_volume_green.3be8c3f40c1b65ce4470e7761d6a02b4.svg";
export { ForwardRef as ReactComponent };